module.exports = __webpack_public_path__ + "img/中繼站2_遊戲背景.d1090bd4.png";